// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__2CAS0","title":"AfterFrontImage_title__3OUxt"};